import { useRef, useState, useEffect } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import useFetchProduct from "./useFetchProduct";
import { useAuth } from "../../../utils/AuthContext";
import useCart from "../../userDashboard/cart/useCart";
function useDisplayProduct() {
  const history = useHistory();
  const { productId } = useParams();
  const [addToCartQuantity, setAddToCartQuantity] = useState(1);
  const { product, getOneProductFn } = useFetchProduct();

  const { isLoggedIn } = useAuth();
  const { addItemToCartFn } = useCart();
  const zoomWrapperRef = useRef(null);
  const zoomImgRef = useRef(null);

  useEffect(() => {
    getOneProductFn(productId);
  }, [productId]);

  const buyNow = () => {
    if (!isLoggedIn) {
      history.push("/signin");
    } else {
      addItemToCartFn({ productId: product?._id, quantity: 1 });
      history.push("/user/dashboard/cart");
    }
  };
  const imageZoom = (e) => {
    if (!zoomWrapperRef.current || !zoomImgRef.current) return;

    const { left, top, width, height } =
      zoomWrapperRef.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    zoomImgRef.current.style.transformOrigin = `${x}% ${y}%`;
  };
  return {
    buyNow,
    imageZoom,
    zoomWrapperRef,
    zoomImgRef,
    addToCartQuantity,
    setAddToCartQuantity,
    product,
  };
}

export default useDisplayProduct;
